import { render, staticRenderFns } from "./PdpActions.vue?vue&type=template&id=f02b2580&scoped=true"
import script from "./PdpActions.vue?vue&type=script&lang=js"
export * from "./PdpActions.vue?vue&type=script&lang=js"
import style0 from "./PdpActions.vue?vue&type=style&index=0&id=f02b2580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02b2580",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-actions%2FPdpActions.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports